import type { EditorState } from "../../vendor/src/features/remotion-editor/editor/state/types";
import type { ImageAsset } from "../../vendor/src/features/remotion-editor/editor/assets/assets";
import { itemOwner } from "./group-split";
import { hasPendingTimelineEdit } from "./edit-ownership";
export function replaceImage(
  state: EditorState,
  clipId: string,
  replacement: ImageAsset,
  scope: "clip" | "source",
): EditorState {
  if (hasPendingTimelineEdit(state))
    throw Error("이동이나 시간 입력을 마친 뒤 적용해 주세요.");
  const doc = state.undoableState,
    item = doc.items[clipId];
  if (item?.type !== "image" || doc.assets[item.assetId]?.type !== "image")
    throw Error("이미지 클립을 다시 선택해 주세요.");
  if (
    replacement.type !== "image" ||
    !replacement.remoteUrl ||
    !Number.isFinite(replacement.width) ||
    !Number.isFinite(replacement.height) ||
    replacement.width <= 0 ||
    replacement.height <= 0
  )
    throw Error("교체할 이미지 원본을 확인해 주세요.");
  if (replacement.id === item.assetId)
    throw Error("다른 이미지를 선택해 주세요.");
  if (doc.assets[replacement.id] && doc.assets[replacement.id] !== replacement)
    throw Error("이미지 원본이 바뀌었습니다. 다시 선택해 주세요.");
  const ids =
    scope === "clip"
      ? [clipId]
      : Object.values(doc.items)
          .filter((i) => i.type === "image" && i.assetId === item.assetId)
          .map((i) => i.id);
  if (ids.some((id) => !!doc.items[id]?.sourceBrandIntro||!!doc.items[id]?.cinematicMotion||!!doc.items[id]?.sourceSlide))
    throw Error("오프닝 카드는 오프닝 카드 문구를 수정해 주세요. 장표와 모션 카드는 원본 설정에서 교체해 주세요.");
  if (
    ids.some((id) => {
      const owner = itemOwner(state, id);
      return !owner || owner.track.locked;
    })
  )
    throw Error(
      "교체 대상 중 잠겼거나 연결을 확인할 수 없는 클립이 있습니다. 선택한 클립만 적용하거나 트랙 잠금을 풀어 주세요.",
    );
  const items = { ...doc.items };
  for (const id of ids) {
    const target = items[id];
    if (target?.type === "image")
      items[id] = { ...target, assetId: replacement.id };
  }
  return {
    ...state,
    undoableState: {
      ...doc,
      items,
      assets: { ...doc.assets, [replacement.id]: replacement },
    },
    assetStatus: {
      ...state.assetStatus,
      [replacement.id]: { type: "uploaded" },
    },
  };
}
